// src/components/Typography.tsx
import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

type AppTypographyProps = TypographyProps & {
  /** Optional custom name for variant shortcuts */
  gradient?: boolean;
};

export const H1: React.FC<AppTypographyProps> = (props) => (
  <Typography 
    variant="h1" 
    color='textPrimary' 
    sx={{ 
      fontSize: (theme: any) => theme.typography.fontSizes.heading2, 
      fontWeight: (theme: any) => theme.typography.fontWeights.semiBold 
    }} 
    {...props} 
  />
);

export const H2: React.FC<AppTypographyProps> = (props) => (
  <Typography 
    variant="h2" 
    sx={{ 
      fontSize: (theme: any) => theme.typography.fontSizes.heading2, 
      fontWeight: (theme: any) => theme.typography.fontWeights.semiBold 
    }} 
    {...props} 
  />
);

export const H3: React.FC<AppTypographyProps> = (props) => (
  <Typography 
    variant="h3" 
    sx={{ 
      fontSize: (theme: any) => theme.typography.fontSizes.heading, 
      mb: 1, 
      fontWeight: (theme: any) => theme.typography.fontWeights.bold 
    }} 
    {...props} 
  />
);

export const H4: React.FC<AppTypographyProps> = (props) => (
  <Typography 
    variant="h4" 
    sx={{ 
      fontSize: (theme: any) => theme.typography.fontSizes.body, 
      fontWeight: (theme: any) => theme.typography.fontWeights.semiBold 
    }} 
    {...props} 
  />
);

export const Body1: React.FC<AppTypographyProps> = (props) => (
  <Typography variant="body1" color='textSecondary' {...props} />
);

export const Body2: React.FC<AppTypographyProps> = (props) => (
  <Typography variant="body2" {...props} />
);

export const Subtitle1: React.FC<AppTypographyProps> = (props) => (
  <Typography variant="subtitle1" color='textSecondary' sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body }} {...props} />
);

export const Subtitle2: React.FC<AppTypographyProps> = (props) => (
  <Typography variant="subtitle2" color='secondary' {...props} />
);

export const Caption: React.FC<AppTypographyProps> = (props) => (
  <Typography variant="caption" {...props} />
);
